// import {showErr} from "../message";
// import aegis from "../aegis";
import answerApi from "../../api/answer";
import {emitEvent} from "../../utils/eventBus/vueEvent";
import Events from "../events";
import {getQceitQuery} from "../../store/modules/ide";
import timer from '../timer'
import Question from '../common/question'

const Base64 = require('js-base64').Base64;

// http://local-qceit.youth.qq.com/ide-edit?ip=4440&lang=c&problem_id=3&exam_tid=2&user_uid=be4783e9-4326-40b2-893a-99a4083365ea&exam_uid=1&exam_grade_uid=1&question_uid=1&question_code=1&question_score=20&timestamp=1621338526&token=8ae0476b01e1dc2fb10c3ad50223e544

const runner = {
  isHttp: false,
  context: null,
}

const init = (context, isHttp) => {
  if (context) {
    runner.context = context;
  }
  runner.isHttp = isHttp;
}

const isHttp = () => {
  return runner.isHttp;
}

const timerTestGetEnd = async (data) => {
  if (!data || !data.SolutionID) {
    return
  }
  const params = getQceitQuery(runner.context.$route.query, {SolutionID: data.SolutionID})
  const res = await answerApi.getTest(params)
  if (res.Code === 0) {
    if (res.data && res.data.Status && res.data.Status != Question.testStatus.STATUS_SEND_SUCC.key) {
      emitEvent(Events.TEST_ENDED, res)
      return
    }
  } else {
    console.error('timerTestGetEnd err:', data)
  }
  timer.setTimer(timerTestGetEnd, timer.timers.testGetEnd.time, timer.timers.testGetEnd.key, res.data);
}

const test = async (code, query, language, isEdit) => {
  const params = getQceitQuery(query, {
    code: Base64.encode(code),
    language: language,
    cbip: true,
    isEdit,
  });
  const res = await answerApi.testCode(params)
  if (res.Code === 0) {
    console.log('test ok:', res)
    if (res.data && res.data.SolutionID) {
      timer.setTimer(timerTestGetEnd, timer.timers.testGetEnd.time, timer.timers.testGetEnd.key, res.data);
    }
  } else {
    console.error('test err:', res)
  }
  emitEvent(Events.TEST_CODE_RES, res)
}

export default {
  init,
  isHttp,
  test,
}
